import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { requestData } from "../../helpers/actions/RequestData";
import { wipeState } from "../../helpers/actions/WipeState";
import {
  LOGOUT_URL,
  LOGIN_PAGE,
  FETCH_LOGOUT_PENDING,
  FETCH_LOGOUT_SUCCESS,
  FETCH_LOGOUT_FAILED,
  SETTINGS_PAGE_EXTENSION,
  VIEWER_PAGE_EXTENSION,
  HELP_PAGE_EXTENSION,
  HOME_PAGE_EXTENSION,
  // MAIN_PAGE,
} from "../../helpers/constants/Constants";
import UserProfilePopup from "./UserProfilePopUp";
import MwhLogo from "../../assets/images/MWHLogo.png";
import AccProjectSelect from "./AccProjectSelect";
import { Link } from "react-router";
import {
  ALL_ASSETS,
  REGIONAL_STATUSES,
  SHOW_TOAST,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer";
import Toast from "react-bootstrap/Toast";
import { getAllRegionAssets } from "../../helpers/axios/assetsAxios";
import { getRegionStatuses } from "../../helpers/axios/projectsAxios";

const TopNavbar = () => {
  const {
    selectedProject,
    userDetails,
    superUserDetails,
    persHubNotifications,
    showToast,
    toastTitle,
    toastBody,
  } = useSelector((state) => state.globalReducer);
  const userData = useSelector((state) => state.userData);
  const [userProfilePopUpState, setUserProfilePopUpState] = useState(false);

  const openUserProfilePopup = (value) => {
    setUserProfilePopUpState(value);
  };

  const dispatch = useDispatch();

  const logOutHandler = async () => {
    const clearState = () => {
      dispatch(wipeState(true));
      window.location.href = LOGIN_PAGE;
    };

    dispatch(
      requestData(
        LOGOUT_URL,
        {
          pending: FETCH_LOGOUT_PENDING,
          success: FETCH_LOGOUT_SUCCESS,
          error: FETCH_LOGOUT_FAILED,
        },
        { withCredentials: true },
        clearState,
      ),
    );
  };

  const fullName = (firstName, lastName) => {
    // Total length of fullName must be less than 50 characters - otherwise reformat
    const fullName = firstName + " " + lastName;

    if (fullName.length <= 50) return fullName.toUpperCase();

    const initialLastName = lastName[0] + ".";
    const shortendLastName = firstName + " " + initialLastName;
    if (shortendLastName.length <= 50) return shortendLastName.toUpperCase();

    const initialFirstName = firstName[0] + ".";
    const shortendFullName = initialFirstName + " " + initialLastName;
    return shortendFullName.toUpperCase();
  };

  const clickEventHandler = (area) => {
    if (area === "projects" && selectedProject.length > 0) {
      fetchAssetData(
        selectedProject[0]?.mviewProjectInfo?.regionCode,
        selectedProject[0]?.mviewProjectInfo?.siteType,
      );
      fetchStatuses(selectedProject[0]?.mviewProjectInfo?.regionCode);
    }
  };
  const fetchAssetData = async (regionCode, assetFilterKey) => {
    if (!regionCode) {
      // console.warn("Region code or site type is not defined.");
      return;
    }
    const tempAssets = await getAllRegionAssets(regionCode, assetFilterKey);

    const sortedData = tempAssets.sort((a, b) => a.name.localeCompare(b.name));
    dispatch(
      updateGlobalState({
        value: sortedData,
        stateName: ALL_ASSETS,
      }),
    );
  };

  const fetchStatuses = async (regionCode) => {
    if (!regionCode) {
      dispatch(
        updateGlobalState({
          value: [],
          stateName: REGIONAL_STATUSES,
        }),
      );
      return;
    }
    const data = await getRegionStatuses(regionCode);
    dispatch(
      updateGlobalState({
        value: data,
        stateName: REGIONAL_STATUSES,
      }),
    );
  };

  return (
    <>
      <div className="bs-docs-section clearfix">
        <div className="row">
          <div className="col-lg-12">
            <div className="bs-component">
              <nav className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
                <div className="container-fluid">
                  <a
                    className="navbar-brand"
                    // href={VIEWER_PAGE} //change to "Home" when exists
                    href="https://mwhtreatment.com/" //change to "Home" when exists
                    style={{ paddingTop: 6, paddingBottom: 6 }}
                       target="_blank"
                        rel="noopener noreferrer"
                  >
                    <img alt="" src={MwhLogo} />
                  </a>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#navbarColor01"
                    aria-controls="navbarColor01"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>

                  <div
                    className="offcanvas-lg offcanvas-start navbar-offcanvas"
                    tabIndex="-1"
                    id="navbarColor01"
                    aria-labelledby="navbarColor01"
                  >
                    <div className="offcanvas-header">
                      <Link
                        className="navbar-brand"
                        id="navbarcolor01"
                        // to={VIEWER_PAGE_EXTENSION}
                        to="https://mwhtreatment.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => clickEventHandler()}
                      >
                        <img alt="" src={MwhLogo} />
                      </Link>

                      <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="offcanvas-body">
                      <ul className="navbar-nav me-auto">
                        <li className="nav-item">
                          <AccProjectSelect />
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to={HOME_PAGE_EXTENSION}
                            onClick={clickEventHandler}
                          >
                            Home
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to={VIEWER_PAGE_EXTENSION}
                            onClick={() => clickEventHandler("projects")}
                          >
                            Projects
                          </Link>
                        </li>

                        {/* <li className="nav-item">
                          <Link
                            className="nav-link"
                            to={VISUALISATION_PAGE_EXTENSION}
                            onClick={clickEventHandler}
                          >
                            mView+
                          </Link>
                       
                        </li> */}
                        {/*<li className="nav-item">
                          <Link
                            className="nav-link"
                            to={PSH_PAGE_EXTENSION}
                            onClick={clickEventHandler}
                          >
                            PSH
                          </Link>
                        </li>*/}

                        {(userDetails?.projectAdmin ||
                          superUserDetails?.admin ||
                          superUserDetails?.cadTemplateUpload) && (
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={SETTINGS_PAGE_EXTENSION}
                              onClick={clickEventHandler}
                            >
                              Admin
                            </Link>
                          </li>
                        )}

                        {/* <li className="nav-item">
                          <Link
                            className="nav-link"
                            to={HELP_PAGE_EXTENSION}
                          >
                            Help
                          </Link>
                        </li> */}

                        {/* <li className="nav-item">
                          <Link
                            className="nav-link"
                            to={HELP_PAGE_EXTENSION}
                            onClick={clickEventHandler}
                          >
                            Help
                          </Link>
                        </li> */}

                        {/* <li
                          className="nav-item"
                          style={{ alignSelf: "flex-end" }}
                        >
                          <a
                            className="nav-link"
                            onClick={() => openUserProfilePopup(true)}
                          >
                            <img
                              src={userData.data.profileImages.sizeX20}
                              alt="https://images.profile.autodesk.com/default/user_X20.png"
                            />
                            <span style={{ marginBottom: 0, marginLeft: 4 }}>
                              {fullName(
                                userData.data.firstName,
                                userData.data.lastName
                              )}
                            </span>
                          </a>
                        </li> */}
                      </ul>

                      <Link
                        className="nav-link help-button"
                        to={HELP_PAGE_EXTENSION}
                        aria-label="Help"
                        title="Help"
                        onClick={clickEventHandler}
                      >
                        <span aria-hidden="true">?</span>
                      </Link>

                      <button
                        type="button"
                        className="nav-link user-button"
                        onClick={() => openUserProfilePopup(true)}
                      >
                        <img
                          src={userData.data.profileImages.sizeX20}
                          alt="https://images.profile.autodesk.com/default/user_X20.png"
                        />
                        <span style={{ marginBottom: 0, marginLeft: 4 }}>
                          {fullName(
                            userData.data.firstName,
                            userData.data.lastName,
                          )}
                        </span>
                        {persHubNotifications.total > 0 && (
                          <div className="button__badge">
                            {persHubNotifications.total}
                          </div>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <Toast
        className="notification-toast"
        show={showToast}
        onClose={() => {
          dispatch(
            updateGlobalState({
              value: false,
              stateName: SHOW_TOAST,
            }),
          );
        }}
        delay={5000}
        autohide
      >
        <Toast.Header className="toast-header">
          <strong className="me-auto">{toastTitle}</strong>
          <small>Just now</small>
        </Toast.Header>
        <Toast.Body>{toastBody}</Toast.Body>
      </Toast>
      <UserProfilePopup
        trigger={userProfilePopUpState}
        setTrigger={openUserProfilePopup}
        logOut={logOutHandler}
      />
    </>
  );
};

export default TopNavbar;
